import gql from 'graphql-tag';

import type { BrandBrief, BrandBriefType } from 'src/data/brief';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_BRIEF } from './schema';

const MUTATION = gql`
  mutation CreateBrandBrief(
    $brandVoiceId: ID!
    $briefType: BrandBriefTypeEnum!
    $name: String!
    $title: String
    $body: String!
  ) {
    createBrandBrief(
      brandVoiceId: $brandVoiceId
      briefType: $briefType
      name: $name
      title: $title
      body: $body
    ) {
      ...BrandBrief
    }
  }
  ${FRAGMENT_BRAND_BRIEF}
`;

interface Variables extends GqlCallVariables {
  brandVoiceId: ID;
  briefType: BrandBriefType;
  name: string;
  title?: string;
  body: string;
}

export const createBrandBrief = async (variables: Variables): Promise<BrandBrief | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BrandBrief>(result.data);
};
